// _config/apiClient.ts
import axios from "axios";

// const BACKEND_URL = "http://localhost:8880/api/v1";
export const BACKEND_URL = "https://api.baapbola.com/api/v1";

/**
 * Universal API request handler
 */
export const axiosRequest = async (
  method = "get" || "post" || "put" || "delete",
  url,
  data = {},
  headers = {},
  isFile = false,
) => {
  try {
    const config = {
      method,
      url: `${BACKEND_URL}${url}`,
      headers: {
        ...(isFile ? {} : { "Content-Type": "application/json" }),
        ...headers,
      },
      ...(method === "get"
        ? { params: data }
        : { data: isFile ? data : JSON.stringify(data) }),
    };

    const response = await axios(config);
    if (response.data.error) {
      if (response.data.code === 3) {
        onErrorLogout();
      }
      if (response.data.code === 401) {
        onErrorLogout();
      }
      throw new Error(response.data.message || "An error occurred");
    }
    return response.data;
  } catch (error) {
    console.log("error: 0", error.response)
    if (axios.isAxiosError(error)) {
      let message = "Request failed";

      if (error.response) {
        message =
          error.response.data?.message || `Error ${error.response.status}`;
      } else if (error.request) {
        message =
          "Network error: Unable to reach the server. Please check your connection.";
      } else if (error.code === "ECONNABORTED") {
        message = "Request timed out. Please try again.";
      } else {
        message = error.message || "Unexpected request error";
      }

      throw {
        isAxiosError: true,
        message,
        status: error.response?.status || null,
      };
      return
    }

    // ✅ Non-Axios unexpected error
    throw { isAxiosError: false, message: error || "Unexpected error occurred" };
  }
};

export const uploadFiles = async ({
  files,
  endpoint = "/uploadMultipleImages",
  fieldName = "files",
}) => {
  if (!files.length) throw new Error("No files selected");

  const formData = new FormData();
  files.forEach((file) => formData.append(fieldName, file));

  try {
    const res = await axios.post(`${BACKEND_URL}${endpoint}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    let message = "Upload failed. Please try again.";

    if (axios.isAxiosError(err)) {
      message = err.response?.data?.message || err.message || message;
    } else if (err instanceof Error) {
      message = err.message;
    }

    console.error("❌ Upload error:", message);
    throw new Error(message);
  }
};

function logout() {
  window.localStorage.removeItem("user");
}

function onErrorLogout() {
  logout();
  window.location.href = "/";
}
